// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/lists/productsList/productsList.scss
// module id = 542
// module chunks = 0